import missingFA from './fa/fa.json'

const MissingMessages = {
  fa: { ...missingFA },
}

export default MissingMessages
